type ViewTransitionDocument = Document & {
  startViewTransition?: (updateCallback: () => void | Promise<void>) => void
}

export function withViewTransition(update: () => void | Promise<void>) {
  const doc = document as ViewTransitionDocument

  if (typeof doc.startViewTransition === 'function') {
    try {
      doc.startViewTransition(update)
      return
    } catch {
      // Fall back to a normal update if view transitions fail
    }
  }

  update()
}

// This is used in the instances where we're doing a hard navigation (i.e. a
// full page reload) but we still want to use view transitions
export function hardNavigateWithViewTransition(path: string) {
  withViewTransition(() => {
    window.location.href = path
  })
}
